import { Button } from 'antd'
import { LoadingOutlined, PlusCircleOutlined } from '@ant-design/icons'

type ButtonFixedProps = {
  onClickButton?: () => void
  text?: string
  icon?: any
  loading?: boolean
  size?: any
  disabled?: boolean
}

const ButtonAdd = ({
  text,
  onClickButton,
  icon,
  loading,
  size,
  disabled,
}: ButtonFixedProps) => {
  return (
    <Button
      style={{
        borderRadius: '5px',
        minWidth: '70px',
        fontWeight: 'bold',
      }}
      type="primary"
      onClick={() => {
        onClickButton && onClickButton()
      }}
      disabled={disabled}
      size={size ? size : 'middle'}
    >
      {loading ? <LoadingOutlined /> : icon ? icon : <PlusCircleOutlined />}
      {text}
    </Button>
  )
}

export default ButtonAdd
